import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OnboardingTour } from "@/features/onboarding/OnboardingTour";
import { useAuth } from "@/hooks/useAuth";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { Content } from "./Content";
import { Footer } from "./Footer";

export function AppShell() {
  const { t } = useTranslation();
  const auth = useAuth();
  const [navOpen, setNavOpen] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia("(min-width: 768px)").matches : true,
  );

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const onChange = () => setNavOpen(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  // On desktop, keep the nav open once the session is ready. On mobile the
  // drawer starts closed (matchMedia) and must stay closed — forcing it open
  // overlays the content and blocks interaction (e2e + real phones).
  useEffect(() => {
    if (
      auth.isAuthenticated &&
      typeof window !== "undefined" &&
      window.matchMedia("(min-width: 768px)").matches
    ) {
      setNavOpen(true);
    }
  }, [auth.isAuthenticated]);

  return (
    <div className={`nbs-shell nbs-shell--topnav${navOpen ? " nbs-shell--nav-open" : ""}`}>
      <a className="nbs-skip-link" href="#main-content">
        {t("shell.skipToContent")}
      </a>
      <Header navOpen={navOpen} onToggleNav={() => setNavOpen((open) => !open)} />
      <Sidebar open={navOpen} />
      <div className="nbs-shell__body">
        <div className="nbs-shell__main">
          <Content>
            <main id="main-content" tabIndex={-1}>
              <Outlet />
            </main>
          </Content>
          <Footer />
        </div>
      </div>
      {auth.isAuthenticated ? <OnboardingTour /> : null}
    </div>
  );
}
